// src/components/layout/Header.tsx
import { AppBar, Toolbar, Box, Button } from '@mui/material';
import { signOut } from 'aws-amplify/auth';
import Logo from '../../assets/logo.svg'; // Adjust the path according to your project structure

const Header = () => {
  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <AppBar 
      position="fixed"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'grey.200',
        backgroundColor: 'background.default',
      }}
    >
      <Toolbar sx={{ px: { xs: 2, sm: 4 }, height: 70 }}>
        <Box 
          component="img"
          src={Logo}
          alt="Phriendly Phishing"
          sx={{ 
            height: 40,
            width: 'auto'
          }}
        />
        <Box sx={{ flexGrow: 1 }} />
        <Button 
          onClick={handleSignOut}
          variant="outlined"
          sx={{ 
            fontWeight: 500,
            px: 3,
            height: 40
          }}
        >
          Sign Out
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
